// extracted by mini-css-extract-plugin
export default {"title":"PaymentToWholesalerDetails_title__OmogO","total":"PaymentToWholesalerDetails_total__GyKY9","edit":"PaymentToWholesalerDetails_edit__y4gtT"};